export default {
  pt: {
    'auth.trocarSenhaCard.success': 'Senha alterada. As outras sessões foram encerradas.',
    'auth.trocarSenhaCard.title': 'Trocar senha',
    'auth.trocarSenhaCard.description': 'Ao trocar, as suas outras sessões são encerradas.',
    'auth.trocarSenhaCard.currentPassword': 'Senha atual',
    'auth.trocarSenhaCard.newPassword': 'Nova senha',
    'auth.trocarSenhaCard.confirmNewPassword': 'Confirmar nova senha',
    'auth.trocarSenhaCard.passwordMismatch': 'A confirmação não confere com a nova senha.',
    'auth.trocarSenhaCard.saveNewPassword': 'Salvar nova senha',
  },
  en: {
    'auth.trocarSenhaCard.success': 'Password changed. Your other sessions have been signed out.',
    'auth.trocarSenhaCard.title': 'Change password',
    'auth.trocarSenhaCard.description': 'Changing your password signs out your other sessions.',
    'auth.trocarSenhaCard.currentPassword': 'Current password',
    'auth.trocarSenhaCard.newPassword': 'New password',
    'auth.trocarSenhaCard.confirmNewPassword': 'Confirm new password',
    'auth.trocarSenhaCard.passwordMismatch': 'The confirmation does not match the new password.',
    'auth.trocarSenhaCard.saveNewPassword': 'Save new password',
  },
  es: {
    'auth.trocarSenhaCard.success': 'Contraseña cambiada. Se cerraron sus otras sesiones.',
    'auth.trocarSenhaCard.title': 'Cambiar contraseña',
    'auth.trocarSenhaCard.description': 'Al cambiarla, se cierran sus otras sesiones.',
    'auth.trocarSenhaCard.currentPassword': 'Contraseña actual',
    'auth.trocarSenhaCard.newPassword': 'Nueva contraseña',
    'auth.trocarSenhaCard.confirmNewPassword': 'Confirmar nueva contraseña',
    'auth.trocarSenhaCard.passwordMismatch': 'La confirmación no coincide con la nueva contraseña.',
    'auth.trocarSenhaCard.saveNewPassword': 'Guardar nueva contraseña',
  },
}
